import { throttleTime } from "rxjs/operators";
import { Component } from "@angular/core";
import { WindowsNotificationService } from "../../../services/windows-notification.service";
import { ReportsService } from "../../../services/reports.service";
import { UserService } from "../../../domain/user-service";

@Component({
  selector: "missing-sub-titles-report",
  templateUrl: "./missing-sub-titles-report.component.html",
  styleUrls: ["./missing-sub-titles-report.component.scss"],
})
export class MissingSubTitlesReportComponent {
  showPreloader: boolean;
  rows = [];
  selected = [];
  columns = [
    { name: "ID", prop: "customId" },
    { name: "Missing Subtitles", prop: "missingSubtitles" },
    { name: "Media Title", prop: "mediaTitle" },
  ];

  constructor(
    private windowsNotificationService: WindowsNotificationService,
    private reportsService: ReportsService,
    private userService: UserService,
  ) {
    windowsNotificationService.ACTIONS.showMissingSubtitlesReport.subscribe(
      () => {
        this.loadReport();

        console.log("refreshing the report");

        let globalState = this.reportsService.reportsGlobalState
          .pipe(throttleTime(3000))
          .subscribe(() => {
            this.loadReport();
          });

        //clean up listeners
        windowsNotificationService.ACTIONS.closeMissingSubtitlesReport
          .subscribe(() => {
            globalState.unsubscribe();
          })
          .unsubscribe();
      },
    );
  }

  clickOnCloseBtnHandler() {
    this.windowsNotificationService.ACTIONS.closeMissingSubtitlesReport.next(
      true,
    );
  }

  private loadReport() {
    this.showPreloader = true;
    this.selected = [];
    this.userService.getCurrentChannel().then(({ id }) => {
      this.reportsService.getMissingSubtitlesReport(id).then((report) => {
        this.rows = this.mapDtos(report);

        this.showPreloader = false;
      });
    });
  }

  private mapDtos(report: Array<any>) {
    return report.map((entry) => {
      let dto: any = { ...entry };

      return dto;
    });
  }
}
